// Rock Chicks Productions — site content (sourced from Marta Pérez Pagès CV)

export const BRAND = {
  name: "Rock Chicks Productions",
  owner: "Marta Pérez Pagès",
  location: "Barcelona, Spain",
  email: "marta@rockchicksproductions.com",
  personalEmail: "martaperezpages@gmail.com",
  phone: "+34 610 360 751",
  eyebrow: "Barcelona · Available for international touring",
  taglineLines: ["FROM STAGE", "TO BOX OFFICE"],
  tagline:
    "Touring & live-events production run with backstage precision — from festival floors to the front-of-house.",
};

// Original supplied logo (black brushstroke on white). Kept for reference.
export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_df1ce579-daff-4625-9af8-fef55a4ad679/artifacts/8q19or1l_image.png";

// White transparent version supplied by client — primary logo for the dark theme.
export const LOGO_WHITE_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_rock-expertise-hub/artifacts/b73ur65q_Logo%20in%20white.png";

export const HERO_BG =
  "https://images.unsplash.com/photo-1657208431551-cbf415b8ef26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxjb25jZXJ0JTIwc3RhZ2UlMjBsaWdodHN8ZW58MHx8fHwxNzg1MjY5NTMxfDA&ixlib=rb-4.1.0&q=85";

export const ABOUT_IMG =
  "https://images.unsplash.com/photo-1563841930606-67e2bce48b78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxiYWNrc3RhZ2UlMjByb2NrJTIwY29uY2VydCUyMHBlcmZvcm1hbmNlfGVufDB8fHx8MTc4NTI2OTU4NXww&ixlib=rb-4.1.0&q=85";

export const MARQUEE_WORDS = [
  "FESTIVALS",
  "TOUR MANAGEMENT",
  "HOSPITALITY",
  "TICKETING",
  "LOGISTICS",
  "ARTIST LIAISON",
  "PRODUCTION",
  "ADVANCING",
];

export const SKILLS = [
  {
    n: "01",
    title: "Festival & Live Ops",
    desc: "Multi-stage festival operations, scheduling and real-time problem solving under pressure.",
    icon: "Music4",
  },
  {
    n: "02",
    title: "Tour Management",
    desc: "National & international tour logistics, advancing, travel and day-to-day coordination.",
    icon: "Bus",
  },
  {
    n: "03",
    title: "Artist & Crew Hospitality",
    desc: "Riders, dressing rooms, catering, VIP, guestlist and accreditation — backstage handled.",
    icon: "Sparkles",
  },
  {
    n: "04",
    title: "Ticketing & Box Office",
    desc: "Box office management, client accounts and ticketing across major venues and promoters.",
    icon: "Ticket",
  },
  {
    n: "05",
    title: "Logistics & Transport",
    desc: "Transport, accreditation, supplier and production coordination across complex sites.",
    icon: "Truck",
  },
  {
    n: "06",
    title: "Artist Liaison",
    desc: "Main point of contact between artists, tour managers and production teams.",
    icon: "Users",
  },
  {
    n: "07",
    title: "Production Management",
    desc: "Production, scheduling and on-site delivery from advance to load-out.",
    icon: "ClipboardList",
  },
  {
    n: "08",
    title: "Merchandise Ops",
    desc: "Sales, stock control, settlements and coordination across touring runs.",
    icon: "ShoppingBag",
  },
];

export const SLIDES = [
  {
    kind: "Tour",
    title: "LORDI — EU Tour 2025",
    role: "Touring & Logistics",
    img: "https://images.unsplash.com/photo-1563841930606-67e2bce48b78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxiYWNrc3RhZ2UlMjByb2NrJTIwY29uY2VydCUyMHBlcmZvcm1hbmNlfGVufDB8fHx8MTc4NTI2OTU4NXww&ixlib=rb-4.1.0&q=85",
  },
  {
    kind: "Festival",
    title: "Primavera Sound",
    role: "Guest Services & Hospitality",
    img: "https://images.unsplash.com/photo-1470229538611-16ba8c7ffbd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxjb25jZXJ0JTIwY3Jvd2QlMjBwdXJwbGUlMjBzdGFnZSUyMGxpZ2h0c3xlbnwwfHx8fDE3ODUyNjk1ODV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    kind: "Festival",
    title: "Rock Fest Barcelona / Cruïlla",
    role: "Logistics Coordinator",
    img: "https://images.unsplash.com/photo-1450044804117-534ccd6e6a3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjb25jZXJ0JTIwY3Jvd2QlMjBwdXJwbGUlMjBzdGFnZSUyMGxpZ2h0c3xlbnwwfHx8fDE3ODUyNjk1ODV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    kind: "Tour",
    title: "Alejandro Fernández — Spain 2025",
    role: "Tour Support",
    img: "https://images.unsplash.com/photo-1506157786151-b8491531f063?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxjb25jZXJ0JTIwY3Jvd2QlMjBwdXJwbGUlMjBzdGFnZSUyMGxpZ2h0c3xlbnwwfHx8fDE3ODUyNjk1ODV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    kind: "Venue",
    title: "O2 Forum Kentish Town — London",
    role: "Box Office Manager",
    img: "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxiYWNrc3RhZ2UlMjByb2NrJTIwY29uY2VydCUyMHBlcmZvcm1hbmNlfGVufDB8fHx8MTc4NTI2OTU4NXww&ixlib=rb-4.1.0&q=85",
  },
];

export const EXPERIENCE = [
  { org: "Madness Live", role: "Hospitality Manager / Production Assistant", note: "Rock Imperium · Rock The Sun · Be Prog!" },
  { org: "Rock Fest Barcelona / Cruïlla", role: "Logistics Coordinator", note: "Multi-stage logistics & scheduling" },
  { org: "Primavera Sound", role: "Guest Services & Hospitality", note: "VIP, guestlist & accreditation" },
  { org: "Il·logic Produccions", role: "Tour Manager", note: "National tours — advancing & travel" },
  { org: "Ticketmaster UK — London", role: "Client Account Manager", note: "Ticketing & client accounts" },
  { org: "Live Nation / Robomagic — London", role: "Promoter Assistant", note: "Promoter-side support" },
  { org: "O2 Forum Kentish Town — London", role: "Box Office Manager", note: "Venue box office" },
  { org: "London Drumstick Company", role: "Artist Liaison Manager", note: "Endorsed artists & industry relations" },
];

export const NOTABLE = [
  "Iron Maiden",
  "Bryan Adams",
  "Jethro Tull",
  "LORDI",
  "Alejandro Fernández",
  "André Rieu",
];

export const FAQ = [
  {
    q: "What is Rock Chicks Productions?",
    a: "Rock Chicks Productions is the live-events and touring company of Marta Pérez Pagès, a Barcelona-based professional specialising in festival operations, tour management, artist liaison, hospitality, ticketing and logistics for international artists and festivals.",
  },
  {
    q: "What services does Rock Chicks Productions offer?",
    a: "Tour management, festival and live-event operations, artist and crew hospitality, ticketing and box office management, logistics and transport coordination, production management and merchandise operations.",
  },
  {
    q: "Where is Rock Chicks Productions based and where does it work?",
    a: "Based in Barcelona, Spain, and available for international touring across Europe and worldwide.",
  },
  {
    q: "Which artists and festivals has Marta worked with?",
    a: "Experience spans tours and festivals including Iron Maiden, Bryan Adams, Jethro Tull, LORDI, Alejandro Fernández, André Rieu, Primavera Sound, Rock Fest Barcelona, Cruïlla and Be Prog!.",
  },
  {
    q: "How can I book Rock Chicks Productions?",
    a: "Use the contact form on this site or call +34 610 360 751 to discuss tours, festivals, hospitality or ticketing.",
  },
  {
    q: "What languages does Marta speak?",
    a: "Native Catalan and Spanish, and proficient English.",
  },
];
